import { createRouteRef, createSubRouteRef, createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

const rootRouteRef = createRouteRef({
  id: "ide-code-scan"
});
createSubRouteRef({
  id: "ide-code-scan-results",
  parent: rootRouteRef,
  path: "/:projectId"
});
createSubRouteRef({
  id: "specific-scan-results",
  parent: rootRouteRef,
  path: "/:projectId/:scanId"
});

const ideCodeScanPlugin = createPlugin({
  id: "ide-code-scan-frontend",
  routes: {
    root: rootRouteRef
  }
});
const IdeCodeScanPage = ideCodeScanPlugin.provide(
  createRoutableExtension({
    name: "IdeCodeScanPage",
    component: () => import('./esm/PluginRouter-0366e83c.esm.js').then((m) => m.HomeRouter),
    mountPoint: rootRouteRef
  })
);

export { IdeCodeScanPage, ideCodeScanPlugin };
//# sourceMappingURL=index.esm.js.map
